import { useQuery } from "@tanstack/react-query";
import { getSingleUser } from "../../services/users";

const useGetSingleUser = (id: number) => {
    return useQuery({
        queryKey: ["users", id],
        queryFn: () => getSingleUser(id),
        staleTime: Infinity,
    });
}

export default useGetSingleUser;